import { useTranslation } from "react-i18next";

interface Props {
    noData: any;
}

function NodataText({
    noData,
}: Readonly<Props>) {
    const [t] = useTranslation();

    const handleText = () => {
        if (noData.length > 0) {
            let text = t("multiple.noData");
            noData.forEach((item: any, index: number) => {
                if (index === 0) {
                    text += t(`layerId.${item.layerId}`);
                } else if (index === noData.length - 1) {
                    text += t("multiple.and") + t(`layerId.${item.layerId}`);
                } else {
                    text += t("multiple.comma") + t(`layerId.${item.layerId}`);
                }
            });
            return text + t("multiple.period");
        }
    }
    return <div style={{ margin: "0 20px 8px 8px" }}>{handleText()}</div>
}

export default NodataText